import { render, staticRenderFns } from "./Facturas.vue?vue&type=template&id=2e4bcd6e"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"
import style0 from "./Facturas.vue?vue&type=style&index=0&id=2e4bcd6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports